// extracted by mini-css-extract-plugin
export default {"promoCode":"PromoCode_promoCode__zU+jg","status":"PromoCode_status__Ht-DA"};